import React from 'react';
var Spacer = function (_a) {
    var className = _a.className;
    return React.createElement("div", { className: className, style: { width: '100%' } });
};
export default Spacer;
